import { Form, Formio } from "@formio/react";
import React, { useEffect, useRef, useState } from "react";
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CSpinner
} from "@coreui/react";
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import SaveQuestionProvider from "../../services/general/saveQuestionsProvider.api";
import GetPatientDiagnosisDetails from "../../services/general/getPatientDiagnosisDetails.api";
import GetQuestionBank from "../../services/general/saveQuestionBank.api";
import PatientQuestionPoa from "./PatientQuestionPoa";
import { useIndexedDB } from "../../context/IndexedContext";
import SaveExtra from "../../services/general/saveExtraData.api";

const ProvidertsPoaBaseline = ({
  patientID,
  loading,
  setLoading,
  saveTreatsShell,
  patientTreatments,
  noteID,
  noteStructureRef,
  diagnosisName
}) => {
  const [newComponent, setNewComponent] = useState(null);
  const [questionValue, setQuestionsValue] = useState([]);
  const [formAnswers, setFormAnswers] = useState([]);
  const [formValue, setFormValues] = useState([]);
  const [dataWithoutValues, setDataWithoutValues] = useState({});
  const [formattedData, setFormattedData] = useState([]);
  const [loadingPoa, setLoadingPoa] = useState(false);
  const formData = useRef([]);

  const formioOptions = {
    readOnly: true,
    renderMode: "html"
  };

  const filterEmptyAnswers = (data) => {
    return data
      .filter((item) => typeof item === "object" && !Array.isArray(item))
      .map((item) => ({
        ...item,
        data: Object.fromEntries(
          Object.entries(item.data).filter(([_, value]) => value !== "")
        )
      }));
  };

  const { getPOACMaster, getOfflineData, getProviderDetails , getCallCenterQuestions} = useIndexedDB()

  // const getCallCenterData = async () => {
  //   try {
  //     const getOfflineDataOfPatient = await getOfflineData()
  //     const getProviderDetailsData = await getProviderDetails()
  //     let tempAnswers = getOfflineDataOfPatient[getProviderDetailsData?.ID]?.[patientID]?.tempAnswersGetPatientDiagnosisDetails || []

  //     // const tempAnswers = await GetPatientDiagnosisDetails(patientID);
  //     const data = JSON.parse(tempAnswers.d);
  //     const formAnswersStr = data?.Data[0]?.DiagnosisDetails;
  //     if (formAnswersStr) {
  //       const tempData = JSON?.parse(formAnswersStr);
  //       const resultData = filterEmptyAnswers(tempData);
  //       setDataWithoutValues(
  //         resultData
  //           .map((item) => item.data)
  //           .reduce((acc, obj) => ({ ...acc, ...obj }), {})
  //       );
  //       setFormAnswers(tempData);
  //       setFormValues(resultData);
  //     }
  //   } catch (e) {
  //     console.error("Error parsing diagnosis details:", e);
  //   }

  //   try {
  //     const POACMaster = await getPOACMaster()
  //     console.log(POACMaster, "POACMaster in POA baseline")
  //     // const componentDatas = await GetQuestionBank("", diagnosisName, "");
  //     const componentData = POACMaster[diagnosisName];
  //     const parsedComponent = JSON?.parse(componentData?.d);
  //     console.log(parsedComponent, 'parsedComponent in POA baseline', diagnosisName)
  //     setNewComponent({ diagnosis: diagnosisName, component: parsedComponent });
  //   } catch (e) {
  //     console.error("Error fetching question bank:", e);
  //   }
  // };




      const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID) => {
  
        const filtered = allPatientHpiData.filter((item) => {
            const patientData = item[patientID]
            // /  return patientData && patientData[noteID]
            return patientData
        })
        console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

        const latest = filtered.at(-1)
        console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
        return latest || null
    }

    const [freeTypeGlobal , setFreeTypeGlobal] = useState('')
  const getCallCenterData = async (diagnosisList) => {
    setLoadingPoa(true);

    // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '');
    // let allData = JSON.parse(data?.d);
    let allData = await getCallCenterQuestions();

    console.log('patinet id allData ', allData);

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      };
    });

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID);

    console.log("call center latest data ---> ", result);


    const convertedData = {};

    const callCenterData = result?.[patientID]?.CCENTER;
     const globalFreeType =    result?.[patientID]?.globalFreeType

    if (callCenterData) {
      Object.keys(callCenterData).forEach((diagnosis) => {



        convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
          question: q.label,
          answer: q.answer,
          freeType: q.freeType,
          type: q?.type,
          freewayRemark : q?.freewayRemark
        }));
      });
    }

    setFreeTypeGlobal(globalFreeType)
    setQuestionsValue(convertedData);
    console.log("Converted Call Center Data", convertedData);

    setLoadingPoa(false);

    return convertedData;
  };

  useEffect(() => {
    getCallCenterData();
  }, []);

  // useEffect(() => {
  //   if (!newComponent || !newComponent.component?.components) return;

  //   const componentKeys = newComponent.component.components.map((c) => c.key);

  //   newComponent.component.components.forEach((comp) => {
  //     if (!dataWithoutValues.hasOwnProperty(comp.key)) {
  //       comp.hidden = true;
  //     }
  //   });

  //   const filteredData = formValue
  //     .map((item) => {
  //       const matchedKeys = Object.keys(item.data).filter((key) =>
  //         componentKeys.includes(key)
  //       );
  //       if (matchedKeys.length > 0) {
  //         const filteredObj = {};
  //         matchedKeys.forEach((key) => {
  //           filteredObj[key] = item.data[key];
  //         });
  //         return filteredObj;
  //       }
  //       return null;
  //     })
  //     .filter(Boolean);

  //   if (filteredData.length > 0) {
  //     const newQuestionValue = [
  //       {
  //         diagnosis: diagnosisName,
  //         data: filteredData
  //       }
  //     ];
  //     setQuestionsValue(newQuestionValue);

  //     const oldNotePoa = patientTreatments
  //       .filter((item, index) =>
  //         noteID === 0 ? index === 0 : item?.data?.noteID < noteID
  //       )
  //       .map((item) => item?.data?.poa || {});

  //     let submission = newQuestionValue.filter((item) => {
  //       const diagnosisExists = oldNotePoa.some((poaItem) =>
  //         Object.keys(poaItem).includes(item.diagnosis)
  //       );
  //       return noteID === 0 ? diagnosisExists : !diagnosisExists;
  //     });

  //     submission =
  //       submission.find((item) => item.diagnosis === diagnosisName) ||
  //       (patientTreatments.length === 1
  //         ? newQuestionValue.find((item) => item.diagnosis === diagnosisName) || {}
  //         : {});

  //     const data = submission.data && submission.data[0];
  //     const formatted = Object.entries(data || {})
  //       .map(([key, value]) => {
  //         const question = key
  //           .replace(/([A-Z])/g, " $1")
  //           .replace(/^./, (str) => str.toUpperCase());
  //         const answer = Array.isArray(value)
  //           ? value.length > 0
  //             ? value.join(", ")
  //             : ""
  //           : value || "No";
  //         return { question, answer };
  //       })
  //       .filter((item) => item.answer !== "");

  //     setFormattedData(formatted);
  //   }

  //   setLoadingPoa(false);
  // }, [newComponent, dataWithoutValues, formValue]);

  return (
    <div>
      {loadingPoa ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80px' }}>
          <CSpinner color="primary" />
        </div>
      ) : (
        <>
          {/* <PatientQuestionPoa 
            noteStructureRef={noteStructureRef}
            index={0}
            form={newComponent}
            submission={{
              diagnosis: diagnosisName,
              data: formValue
            }}
            options={formioOptions}
            diagnosisName={diagnosisName}
          />

          {formattedData.length > 0 && (
            <div style={{ marginBottom: "10pt" }}>
              {formattedData.map((item, index) => (
                <p className="mt-1" key={index} style={{ margin: 0 }}>
                  <strong>{item.question}</strong> - {item.answer}
                </p>
              ))}
            </div>
          )} */}

          {(() => {

            const data = questionValue?.[diagnosisName] || [];
            console.log("data-->",data, questionValue,diagnosisName)
            if (!data.length) return null;
            console.log("poa data==>",  data, questionValue);

            return (
              <>
                
                <div className="" style={{ marginBottom: '10pt' }}>
                  {/* {freeTypeGlobal && <div>{freeTypeGlobal} </div>} */}
                        {data.map((item, index) => (
                          <div
                            className="mt-1"
                            key={index}
                            style={{
                              // textDecoration: (item?.type == 'Header' || item?.type == 'subHeader') ? 'underline' : 'none',
                              fontWeight: (item?.type == 'Header' || item?.type == 'subHeader') ? 'bold' : 'none',
                              fontSize:  item?.type == 'Header' ? '15.5px' : '' ,
                              gap: '5px',
                              margin: 0,


                            }}
                          >
                            {item?.freewayRemark && <div>{item?.freewayRemark} </div>}
                             <div className="d-flex">
                              <p style={{ margin: 0 }}>
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    textDecoration: item?.type === 'Header' ? 'underline' : 'none',
                                    fontSize: item?.type === 'Header' ? '16.5px' : '15px',
                                  }}
                                >
                                  {item?.type === 'Header'
                                    ? item.question
                                    : item?.type === 'subHeader'
                                      ? `${item.question} :`
                                      : `${item.question} - `}
                                </span>

                                <span
                                  style={{
                                    fontSize: '14px',
                                    color: '#fff',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: item.answer?.replace(/color\s*:\s*[^;"]+;?/gi, ''),
                                  }}
                                />
                              </p>
                            </div>
                            {item?.freeType && <div><strong>FreeType:</strong> <span style={{
                                    fontSize: '14px',
                                    color: '#fff',
                                  }} dangerouslySetInnerHTML={{ __html: item?.freeType?.replace(/color\s*:\s*[^;"]+;?/gi, '') }}></span> </div>}
                          </div>
                        ))}
                      </div>

              </>

            );
          })()}
        </>
      )}
    </div>
  );
};

export default ProvidertsPoaBaseline;
